// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__HW6gY","header":"ReportDetails_header__12ovd","title":"ReportDetails_title__2a8lz","left":"ReportDetails_left__2KzRc"};